<template>
<div class="place-viewer">
  <div class="has-text-centered" v-if="isLoading">
    <button
      disabled="disabled"
      class="button is-loading is-disabled is-white"
      style="background-color: #f5f5f5"
    >
      ...
    </button>
  </div>
  <div v-if="!isLoading && Place.id">
    <tabs type="boxed" :on-tab-click="tabChanges">
        <tab-item label="Dados do Lugar">
          <div style="padding: 10px">
            <router-link
              tag="button"
              class="button is-primary is-small"
              :to="`/${$route.params.lang}/places/${Place.id}/edit`"
            >
              Editar dados não traduzíveis
            </router-link>
          </div>
          <div class="field" v-if="Place.coverImage">
            <h5 class="title is-5">Imagem de capa</h5>
            <div class="control">
              <img
                alt="imagem de capa"
                :src="Place.coverImage['240x260']"
                style="max-width: 100%"
              />
            </div>
          </div>
          <div class="field">
            <h5 class="title is-5">Nome</h5>
            <div class="control">{{Place.name}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Ativo</h5>
            <div class="control">
              <span v-if="Place.active">Sim</span>
              <span v-else>Não</span>
            </div>
          </div>
          <div class="field">
            <h5 class="title is-5">Descrição Curta</h5>
            <div class="control">{{Place.shortDescription}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Descrição completa</h5>
            <div class="control">{{Place.longDescription}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Informações</h5>
            <div class="control">{{Place.informations}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Operação</h5>
            <div class="control">{{Place.operation}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Contatos</h5>
            <div class="control">{{Place.contacts}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Site</h5>
            <div class="control">{{Place.site}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Idioma</h5>
            <div class="control">{{Place.language}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Categoria</h5>
            <div class="control">{{PlaceCategory}}</div>
          </div>
          <div class="field">
            <h5 class="title is-5">Endereço</h5>
            <div class="control">{{Place.addressFormatted}}</div>
            <div class="control">
              <gmap-map
                :center="{
                  lat: Place.addressLatitude || 0,
                  lng: Place.addressLongitude || 0
                }"
                :zoom="15"
                style="width: 100%; height: 300px"
              >
                <gmap-marker
                  :position="{
                    lat: Place.addressLatitude || 0,
                    lng: Place.addressLongitude || 0
                  }"
                />
              </gmap-map>
            </div>
          </div>
        </tab-item>
        <tab-item label="Imagens do Lugar">
          <div style="padding: 10px">
            <router-link
              tag="button"
              class="button is-primary is-small"
              :to="`/${$route.params.lang}/places/${Place.id}/edit?tab=1`"
            >
              Editar Imagens
            </router-link>
          </div>
          <image-grid
            image-size="150x150"
            :images="PlaceImages"
            :is-loading="placeImagesIsLoading"
          />
        </tab-item>
        <tab-item label="Desafios">
          <div class="has-text-centered" v-if="PlaceQuizes['pt'] && PlaceQuizes['pt'].length === 0">
            <router-link
              :to="`/pt/places/${Place.id}/quiz?lang=pt`"
              class="button is-primary is-large"
              tag="button"
            >
              Criar Desafio no Idioma: pt
            </router-link>
          </div>
          <tabs v-else type="toggle" is-full-width :on-tab-click="tabQuizChanges">
            <tab-item
              v-for="lang in Languages"
              :key="lang"
              :label="lang"
            >
              <quiz-viewer
                :quizes="addFieldsToQuizes(PlaceQuizes[lang])"
                :is-loading="placeQuizesIsLoading"
                :can-be-edited="true"
                :can-be-deleted="me.role !== 'moderator'"
              >
                <button
                  class="button is-primary is-large"
                  slot="empty-quizes"
                  @click="showQuizTranslateModal(lang)"
                >
                  Traduzir Desafio para {{lang}}
                </button>
              </quiz-viewer>
            </tab-item>
          </tabs>
        </tab-item>
        <tab-item label="Traduções do Lugar">
          <translations-list :translations="GetPlaceTranslations">
            <template slot-scope="data">
              <div class="control has-addons" v-if="data.place.isTranslated">
                <button
                  class="button is-small is-primary"
                  @click="EditPlaceTranslation(data.place.place)"
                >
                  Editar
                </button>
                <button
                  class="button is-small is-danger"
                  @click="DelPlaceTranslation(data.place.place)"
                  v-if="me.role !== 'moderator'"
                >
                  Apagar
                </button>
              </div>
              <div class="control has-addons" v-else>
                <button
                  class="button is-small"
                  @click="CreatePlaceTranslation(data.lang)"
                >
                  Criar
                </button>
              </div>
            </template>
          </translations-list>
          <div
            style="padding: 10px"
            class="has-text-centered"
            v-if="isDeletingTranslation"
          >
            Apagando...
            <button
              disabled="disabled"
              class="button is-loading is-disabled is-white"
              style="background-color: #f5f5f5"
            >
              ...
            </button>
          </div>
        </tab-item>
        <tab-item label="Qr Codes">
          <div class="columns" style="margin-top: 20px">
            <div class="column">
              <h5 class="title is-5">Checkin</h5>
              <qr-code-viewer
                :is-loading="isLoadingCheckinQrCode"
                :url="PlaceQrCodes['checkin']"
                :allow-download="true"
                name="Checkin"
              />
            </div>
            <div class="column">
              <h5 class="title is-5">Desafio</h5>
              <qr-code-viewer
                :is-loading="isLoadingCheckinQrCode"
                :url="PlaceQrCodes['quiz']"
                :allow-download="true"
                name="Quiz"
              />
            </div>
            <div class="column">
              <h5 class="title is-5">Avaliações</h5>
              <qr-code-viewer
                :is-loading="isLoadingCheckinQrCode"
                :url="PlaceQrCodes['rating']"
                :allow-download="true"
                name="Avaliacao"
              />
            </div>
          </div>
        </tab-item>
        <tab-item label="Avaliações">
          <rating-list
            :items="PlaceRatings.items"
            :pagination-controller="{ total: PlaceRatings.total, limit: PlaceRatings.limit }"
            :media="PlaceRatings.resume.media"
            @change-page="changeRatingPage"
            can-delete
            @delete="deleteRating"
          />
        </tab-item>
        <tab-item label="Contribuições">
          <image-grid
            image-size="240x260"
            :images="PlaceContributions.items"
            :is-loading="placeContributionsIsLoading"
            :pagination-controller="{ total: PlaceContributions.total || 0, limit: 100 }"
            @page-change="(page) => getPlaceContributions({ placeId: place.id, params: { limit: 100, skip: 100 * (page - 1) } })"
            @remove="removeContribution"
            empty-mensage="Não existem contribuições cadastradas"
            allow-remove
            view-original
          />
        </tab-item>
        <tab-item label="Moderadores" v-if="me.role !== 'moderator'">
          <p class="control">
            <label class="label">Adicionar Moderador</label>
            <span class="select">
              <select v-model="moderatorToAdd">
                <option :value="null" disabled selected>Selecione...</option>
                <option
                  v-for="(item, index) in Users.items"
                  :value="item.id"
                  :key="index"
                >
                {{item.firstName}} {{item.lastName}}
                </option>
              </select>
            </span>
            <button
              class="button"
              :disabled="moderatorToAdd === null"
              @click="addModerator"
            >
              Adicionar
            </button>
          </p>
          <p class="control">
            <tag
              rounded
              closable
              type="primary"
              :on-close="() => removeModerator({ id: m.id })"
              v-for="(m, i) in Place.moderators"
              :key="i"
              style="margin-right: 10px"
            >
            {{m.firstName}} {{m.lastName}}
            </tag>
          </p>
        </tab-item>
      </tabs>
  </div>
  <modal
    :title="`Traduzir Desafio para ${quizTranslateTo}`"
    :width="1000"
    :is-show="quizTranslateModal"
    transition="fadeDown"
    :show-ok="false"
    :show-cancel="false"
    @close="quizTranslateModal=false"
  >
    <quiz-translator :lang="quizTranslateTo" />
  </modal>
</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import TranslationsList from './TranslationsList'
import QuizViewer from './QuizViewer'
import ImageGrid from './ImageGrid'
import QrCodeViewer from './QrCodeViewer'
import QuizTranslator from './QuizTranslator'
import RatingList from './RatingList'

export default {
  name: 'PlaceViewer',
  components: { TranslationsList, QuizViewer, ImageGrid, QrCodeViewer, QuizTranslator, RatingList },
  data: () => ({
    placeQuizesIsLoading: false,
    placeImagesIsLoading: false,
    placeContributionsIsLoading: false,
    isLoading: false,
    isDeletingTranslation: false,
    isLoadingCheckinQrCode: false,
    quizTranslateModal: false,
    quizTranslateTo: 'en',
    moderatorToAdd: null
  }),
  computed: {
    ...mapGetters([
      'Languages',
      'PlaceQuizes',
      'Place',
      'PlaceImages',
      'DefaultLanguage',
      'PlaceLanguages',
      'PlaceQrCodes',
      'me'
    ]),
    ...mapState({
      PlaceRatings: state => state.place.currentPlaceRatings,
      Users: state => state.user.users,
      PlaceContributions: state => state.place.currentPlaceContributions
    }),
    PlaceCategory () {
      const { category, language } = this.Place
      if (category && language) {
        return category[`name_${language}`]
      }
      return ''
    },
    GetPlaceTranslations () {
      let translations = {}
      this.Languages.map(item => { translations[item] = { isTranslated: false } })
      this.PlaceLanguages.map(item => {
        if (this.Languages.indexOf(item.language) > -1) {
          translations[item.language].isTranslated = true
          translations[item.language].place = item
        }
      })
      return translations
    },
    getPlaceQuizPtIdUrl () {
      if (this.PlaceQuizes['pt'] && this.PlaceQuizes['pt'].length > 0) {
        return `/${this.PlaceQuizes['pt'][0].id}`
      }
      return ''
    }
  },
  methods: {
    ...mapActions([
      'RetrievePlace',
      'SetCurrentPlace',
      'SetCurrentPlaceImages',
      'RetrievePlaceImages',
      'RetrievePlaceQuizes',
      'RetrievePlaceLanguage',
      'SetCurrentPlaceLanguages',
      'DeletePlaceLanguage',
      'RetrievePlaceCheckinQrCode',
      'RetrievePlaceRatingQrCode',
      'RetrievePlaceQuizQrCode',
      'getPlaceRatings',
      'deletePlaceRating',
      'getUsers',
      'addModeratorToPlace',
      'removePlaceModerator',
      'getPlaceContributions',
      'deletePlaceContribution'
    ]),
    async removeContribution (id) {
      try {
        await this.deletePlaceContribution({ placeId: this.Place.id, id })
        this.$notify.open({
          type: 'success',
          content: 'Moderador adicionado com sucesso',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível remover a Contribuição.',
          duration: 10000
        })
      }
    },
    async getModerators () {
      try {
        await this.getUsers({ params: { limit: 100, role: 'moderator' } })
      } catch (error) {
        console.log(error)
      }
    },
    async addModerator () {
      try {
        await this.addModeratorToPlace({ placeId: this.Place.id, data: { userId: this.moderatorToAdd } })
        this.$notify.open({
          type: 'success',
          content: 'Moderador adicionado com sucesso',
          duration: 10000
        })
      } catch (error) {
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível adicionar o moderador ao Lugar.',
          duration: 10000
        })
      }
    },
    async removeModerator ({ id }) {
      try {
        await this.removePlaceModerator({ placeId: this.Place.id, id })
      } catch (error) {
        console.log(error)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível remover este Moderador',
          duration: 10000
        })
      }
    },
    async GetPlaceData (place) {
      try {
        if (place.id) {
          place.coverImage
            ? await this.GetPlaceImages()
            : await this.SetCurrentPlaceImages([])
          await this.GetPlaceQuizes(this.DefaultLanguage)
          await this.GetPlaceLanguages()
          await this.getCheckInQrCode()
          await this.getRatingQrCode()
          await this.getPlaceRatings({ id: place.id, params: { limit: 100 } })
          await this.getPlaceContributions({ placeId: place.id, params: { limit: 100 } })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async changeRatingPage (page = 1) {
      try {
        await this.getPlaceRatings({ id: this.Place.id, params: { limit: 100, skip: this.PlaceRatings.limit * (page - 1) } })
      } catch (error) {
        console.log(error)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível obter as Avaliações.',
          duration: 10000
        })
      }
    },
    async deleteRating (rating) {
      try {
        await this.deletePlaceRating({ placeId: this.Place.id, id: rating.id })
        this.$notify.open({
          type: 'success',
          content: 'Avaliação apagada com sucesso',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível apagar esta avaliação',
          duration: 10000
        })
      }
    },
    GetPlaceImages () {
      const { language, id } = this.Place
      this.placeImagesIsLoading = true
      this.RetrievePlaceImages({ force: true, params: { limit: null, skip: null, language, id } })
        .then(
          success => {
            this.placeImagesIsLoading = false
          },
          error => {
            this.placeImagesIsLoading = false
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter as imagens do Lugar.',
              duration: 10000
            })
          }
        )
    },
    GetPlaceQuizes (language) {
      const { id } = this.Place
      this.placeQuizesIsLoading = true
      // this.SetCurrentPlaceQuizes([])
      this.RetrievePlaceQuizes({ params: { limit: null, skip: null, language, id } })
        .then(
          success => {
            this.placeQuizesIsLoading = false
            this.getQuizQrCode()
          },
          error => {
            this.placeQuizesIsLoading = false
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter os Desafios do Lugar.',
              duration: 10000
            })
          }
        )
    },
    GetPlaceLanguages () {
      const { id } = this.Place
      this.SetCurrentPlaceLanguages([])
      this.RetrievePlaceLanguage({ params: { id } })
        .then(
          success => {},
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter as traduções do Lugar.',
              duration: 10000
            })
          }
        )
    },
    EditPlaceTranslation (place) {
      // console.log('currentPlace', this.Place)
      const { id } = this.Place
      this.SetCurrentPlace({
        ...place,
        category: this.Place.category,
        addressFormatted: this.Place.addressFormatted,
        addressLatitude: this.Place.addressLatitude,
        addressLongitude: this.Place.addressLongitude
      })
      // console.log('novo currentPlace', this.Place)
      this.$router.push(`/${this.$route.params.lang}/places/${id}/translate/${place.id}/edit?lang=${place.language}`)
    },
    CreatePlaceTranslation (lang) {
      this.$router.push(`/${this.$route.params.lang}/places/${this.Place.id}/translate?lang=${lang}`)
    },
    DelPlaceTranslation (translation) {
      this.isDeletingTranslation = true
      this.DeletePlaceLanguage(
        {
          params: {
            placeId: this.Place.id,
            translationId: translation.id
          },
          translation
        }
      )
        .then(
          success => {
            this.isDeletingTranslation = false
            this.$notify.open({
              type: 'success',
              content: 'Tradução apagada com sucesso.',
              duration: 10000
            })
          },
          error => {
            this.isDeletingTranslation = false
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível apagar a tradução no momento.',
              duration: 10000
            })
          }
        )
    },
    tabQuizChanges (tab) {
      let lang = this.Languages[tab]
      if (this.Place.id && (!this.PlaceQuizes[lang] || this.PlaceQuizes[lang].length === 0)) {
        this.GetPlaceQuizes(lang)
      }
    },
    addFieldsToQuizes (quizes) {
      if (quizes) {
        let q = [...quizes]
        for (let i = 0; i < q.length; i++) {
          q[i].placeId = this.Place.id
        }
        return q
      }
      return []
    },
    tabChanges (tab) {
      if (tab === 3) {
        this.GetPlaceLanguages()
      }
      if (tab === 4) {
        this.getCheckInQrCode()
        this.getRatingQrCode()
      }
    },
    getCheckInQrCode () {
      const { id } = this.Place
      this.isLoadingCheckinQrCode = true
      this.RetrievePlaceCheckinQrCode(id)
        .then(
          success => {
            this.isLoadingCheckinQrCode = false
          },
          error => {
            console.log(error.response)
            this.isLoadingCheckinQrCode = false
          }
        )
    },
    getRatingQrCode () {
      const { id } = this.Place
      this.isLoadingCheckinQrCode = true
      this.RetrievePlaceRatingQrCode(id)
        .then(
          success => {
            this.isLoadingCheckinQrCode = false
          },
          error => {
            console.log(error.response)
            this.isLoadingCheckinQrCode = false
          }
        )
    },
    getQuizQrCode () {
      const { id } = this.Place
      this.isLoadingCheckinQrCode = true
      if (this.PlaceQuizes[this.DefaultLanguage] && this.PlaceQuizes[this.DefaultLanguage].length > 0) {
        this.RetrievePlaceQuizQrCode({
          params: {
            placeId: id,
            quizId: this.PlaceQuizes[this.DefaultLanguage][0].id
          }
        })
          .then(
            success => {
              this.isLoadingCheckinQrCode = false
            },
            error => {
              console.log(error.response)
              this.isLoadingCheckinQrCode = false
            }
          )
      }
    },
    showQuizTranslateModal (lang) {
      this.quizTranslateModal = true
      this.quizTranslateTo = lang
    }
  },
  async created () {
    try {
      this.isLoading = true
      await this.RetrievePlace(this.$route.params.id)
      await this.GetPlaceData(this.Place)
      await this.getModerators()
      this.isLoading = false
    } catch (error) {
      console.log(error)
      this.isLoading = false
      this.$notify.open({
        type: 'danger',
        content: 'Não foi possível obter os dados do Lugar.',
        duration: 10000
      })
    }
  }
}
</script>

<style>
  .place-viewer .field {
    margin-bottom: 20px;
    border-bottom: 1px dotted #ccc;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceViewer.vue